"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _carbonComponentsReact = require("carbon-components-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PhoneInputValidator = _interopRequireDefault(require("./PhoneInputValidator"));
var _PhoneFormatter = _interopRequireDefault(require("../../common/Formatters/PhoneFormatter"));
var _LabelFactory = _interopRequireDefault(require("../../common/FormElement/LabelFactory"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.phone-input {\n  width: 100%;\n  margin-bottom: 1.5rem; }\n  .phone-input .bx--label {\n    color: #4c4c4c; }\n  .phone-input .tooltip {\n    color: #a8a8a8; }\n";
  const fileName = "PhoneInput_PhoneInput";
  const element = document.querySelector("style[data-sass-component='PhoneInput_PhoneInput']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const PhoneInput = props => {
  const formatter = _PhoneFormatter.default;
  const [expectedCaretPositionOnChange, setExpectedCaretPositionOnChange] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    const currentElement = document.getElementById(props.id);
    const isUsingElement = document.activeElement === currentElement;
    if (isUsingElement) {
      maintainCaretPosition(currentElement, expectedCaretPositionOnChange);
    }
  });
  const maintainCaretPosition = (usingElement, expectedPosition) => {
    // due to text replacement on formatting
    usingElement.setSelectionRange(expectedPosition, expectedPosition);
  };
  const getExpectedCaretPositionOnChange = (inputValue, formattedValue) => {
    const currentCaretPosition = document.getElementById(props.id).selectionStart;
    const characterWasAddedInFormatting = formattedValue.length - inputValue.length === 1;
    if (!characterWasAddedInFormatting) {
      return currentCaretPosition;
    }
    const possibleAddedCharacterBeforeCaret = formattedValue.substring(currentCaretPosition, currentCaretPosition - 1);
    const spaceWasAddedBeforeCaret = possibleAddedCharacterBeforeCaret === ' ';
    if (spaceWasAddedBeforeCaret) {
      return currentCaretPosition + 1;
    }
    return currentCaretPosition;
  };
  const onChange = event => {
    const value = event.target.value;
    const formattedValue = formatter.format(value);
    const isPatternValid = formattedValue ? _PhoneInputValidator.default.validatePattern(formattedValue) : true;
    const error = isPatternValid ? null : props.invalidPatternText;
    const expectedCaretPosition = getExpectedCaretPositionOnChange(value, formattedValue);
    setExpectedCaretPositionOnChange(expectedCaretPosition);
    props.onChange(event, formattedValue, error);
  };
  const onBlur = e => {
    if (props.onBlur) {
      props.onBlur(e);
    }
  };
  const customLabel = /*#__PURE__*/_react.default.createElement("div", null, props.label && _LabelFactory.default.create(props.label, props.required), props.tooltip && /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip"
  }, props.tooltip));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'phone-input',
    onBlur: onBlur
  }, /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TextInput, {
    id: props.id,
    labelText: customLabel,
    name: props.id,
    onChange: onChange,
    placeholder: props.placeholder,
    helperText: props.helperText ? props.helperText : false,
    invalid: Boolean(props.invalidText),
    invalidText: props.invalidText,
    value: props.value
  }));
};
PhoneInput.propTypes = {
  id: _propTypes.default.string.isRequired,
  label: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  invalidPatternText: _propTypes.default.string.isRequired,
  required: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  helperText: _propTypes.default.string,
  value: _propTypes.default.string,
  invalidText: _propTypes.default.string,
  type: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  tooltip: _propTypes.default.string
};
PhoneInput.defaultProps = {
  type: 'PhoneInput' // todo, https://stackoverflow.com/q/72446985/4840661
};
var _default = exports.default = PhoneInput;